import { Component, OnInit } from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import * as _ from 'underscore';
import {ServiceProviderPriceService} from '../../services/service-provider-price.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-update-service-provider-pricing-modal',
  templateUrl: './update-service-provider-pricing-modal.component.html',
  styleUrls: ['./update-service-provider-pricing-modal.component.scss']
})
export class UpdateServiceProviderPricingModalComponent extends ModalExtended implements OnInit {

  data:any;
  formSearch:FormGroup;


  constructor( private servicePriceHandler: ServiceProviderPriceService,
               private alerta: AlertaService) {
    super();
  }

  ngOnInit() {
      this.formSearch=new FormGroup(
          {
              'prefix':new FormControl(this.data.element.prefix,[Validators.required,Validators.pattern('^[0-9]+$')]),
              'company':new FormControl(this.data.element.company,Validators.required),
              'price':new FormControl(this.data.element.price,[Validators.required,Validators.pattern('^[0-9]+[.][0-9]{1,6}$')]),
              'type':new FormControl(this.data.element.type,Validators.required)
          })
  }

  onExit(data){
      this.applyCallback(data);
      this.close();
  }

  updateData(form){
      if(form.valid) {
          let element = form.value;
          for(let x in element){
              if(element[x] !== this.data.element[x]){
                  delete this.data.element[x];
                }else{
                  delete element[x];
              }
          }
          let data=Object.assign({},element,this.data.element);

          this.servicePriceHandler.putServiceProviderPrice(data)
                .subscribe(result => {
                    this.onExit({edit:true,element:result.data});
                }, error => {
                    //console.log(error);
                    this.alerta.addAlert('error','Something went wrong')
                }, () => {
                    this.alerta.addAlert('success','Response Delay Config Updated Succesfully!!')
                })
        }
  }



}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/modals/update-service-provider-pricing-modal/update-service-provider-pricing-modal.component.ts